import { motion } from "framer-motion";

// A generic "fade-lift on scroll" wrapper used across sections and cards.
const SectionReveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay }}
    >
        {children}
    </motion.div>
);

export default SectionReveal;
